import { Moment } from 'moment-timezone';

export function formatCutoff(cutoffTime: Moment) : string {
  const isEndOfDay = cutoffTime.hour() === 23 && cutoffTime.minutes() === 59;
  return cutoffTime.format(isEndOfDay ? 'Do MMM YYYY ([End of day])' : 'Do MMM YYYY (HH:mm)');
}
